import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ArticleCard from '../components/ArticleCard';
import { getJournalist } from '../api/strapiClient';

export default function JournalistProfile() {
  const { id } = useParams();
  const [journalist, setJournalist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    getJournalist(id)
      .then((res) => {
        if (!cancelled) setJournalist(res.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Unknown error');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) return <main className="page state-message">Loading profile…</main>;
  if (error)
    return (
      <main className="page state-message state-message--error">
        Couldn't reach the newsroom. {error}
      </main>
    );
  if (!journalist) return <main className="page state-message">Journalist not found.</main>;

  const { firstName, lastName, homepageUrl, bio, articles, publications } = journalist;
  const journalistArticles = articles || [];
  const journalistPublications = publications || [];

  return (
    <main className="page">
      <Link to="/" className="back-link">
        ← Back to the wire
      </Link>

      <section className="journalist-profile">
        <h1 className="journalist-profile__name">
          {firstName} {lastName}
        </h1>
        {bio && <p className="journalist-profile__bio">{bio}</p>}
        {homepageUrl && (
          <a
            href={homepageUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="journalist-profile__link"
          >
            View author page ↗
          </a>
        )}
        {journalistPublications.length > 0 && (
          <div className="journalist-profile__publications">
            {journalistPublications.map((pub) => (
              <a
                key={pub.id}
                href={pub.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="journalist-profile__publication"
              >
                {pub.name}
              </a>
            ))}
          </div>
        )}
      </section>

      <h2 className="section-heading">Articles by {firstName} {lastName}</h2>

      {journalistArticles.length ? (
        <div className="article-list">
          {journalistArticles.map((article) => (
            <ArticleCard key={article.id} article={{ ...article, journalist }} />
          ))}
        </div>
      ) : (
        <p className="state-message">No articles on file yet.</p>
      )}
    </main>
  );
}
